import gql from 'graphql-tag'
import createQuery from 'legacy/apollo/createQuery'

export const WarehouseEarlyHourDocument = gql`
  query warehouseEarlyHour($warehouseId: ID!) {
    warehouse(id: $warehouseId) {
      earlyPickingHour
    }
  }
`

export interface WarehouseEarlyHourData {
  warehouse: {
    earlyPickingHour: number
  }
}

export interface WarehouseEarlyHourVariables {
  warehouseId: number
}

export const warehouseEarlyHourQuery = createQuery<
  WarehouseEarlyHourData,
  WarehouseEarlyHourVariables
>(WarehouseEarlyHourDocument)
